const DEFAULT_LOCAL_BACKEND_URL = 'http://localhost:8000/api/v1';
const DEFAULT_PRODUCTION_BACKEND_URL =
  'https://mes-backend-1036521397348.southamerica-east1.run.app/api/v1';

function normalizeBackendUrl(url) {
  if (!url || typeof url !== 'string') return '';
  return url.trim().replace(/\/+$/, '');
}

const runtimeUrl = window.__RUNTIME_CONFIG__?.BACKEND_URL ?? '';

const envUrl = import.meta.env.VITE_REACT_APP_BACKEND_URL;
const defaultUrl =
  import.meta.env.VITE_NODE_ENV === 'production'
    ? DEFAULT_PRODUCTION_BACKEND_URL
    : DEFAULT_LOCAL_BACKEND_URL;

const BACKEND_URL =
  normalizeBackendUrl(runtimeUrl || envUrl || defaultUrl) || defaultUrl;

export default BACKEND_URL;
